export default "__VITE_ASSET__Cl86HKyc__"